import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { price } from '@app/_models/price';
import { headervalue } from 'src/headervalue/header';
import {Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({ providedIn: 'root' })


export class PriceService {
  url: string;
  constructor(private http: HttpClient) { }

  getPrice() {
    var temp = this.http.get<any>(`${environment.apiUrl}/price/getPriceList`,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }
  

  addPrice(PriceParam: price): Observable<price> {
    return this.http.post<price>(`${environment.apiUrl}/price/priceAdd`,PriceParam, httpOptions).pipe( );
  }

  updatePrice(PriceParam: price): Observable<price> {
    return this.http.post<price>(`${environment.apiUrl}/price/priceUpdate`,PriceParam, httpOptions).pipe( );
  }
 
  deletePrice(id) {
    return this.http.delete<price>(`${environment.apiUrl}/price/priceDelete/`+id, httpOptions).pipe( );
  }
}